export class Utility {
	
	static shiftCollectionUp(collection:any[], item:any) {
		let index = collection.indexOf(item);
		if (index <= 0) {
			return; // already at the highest 'to the user' point
		}
		
		// now add the label up.
		collection.splice(index, 1);
		collection.splice(index-1, 0, item);
	}
	
	static shiftCollectionDown(collection:any[], item:any) {
		let index = collection.indexOf(item);
		if (index >= collection.length - 1) {
			return; // already at the maximum
		}
		
		if (index >= 0) {
			collection.splice(index, 1);
			collection.splice(index+1, 0, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/models/utility.ts